var _defs, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    width: 62,
    height: 62,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fieldGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 42.9863,
    y1: 7.0127,
    x2: 22.0144,
    y2: 51.9871
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BCD6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6787D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edgeGradient",
    gradientUnits: "userSpaceOnUse",
    x1: 55.4541,
    y1: 42.7529,
    x2: 9.5471,
    y2: 16.2485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3057A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7AC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shadowGradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "shadow",
    r: 26.5,
    cx: 32.5,
    cy: 29.5,
    fill: "url(#shadowGradient)",
    transform: "matrix(1.0648,0.0,0.0,1.064822,-2.1,1.0864)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "field",
    r: 25.8,
    cx: 31,
    cy: 31,
    fill: "url(#fieldGradient)",
    stroke: "url(#edgeGradient)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    fill: "white"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "23,25 35,25 35,44 39,44 39,48 23,48 23,44 27,44 27,28 23,28 23,25"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 31,
    cy: 17
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.d2a07d894c19382ddacb240a69c806b5.svg";
export { ForwardRef as ReactComponent };